import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('channel-icon', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('channel-icon');

      return new ViewModel(params, element);
    },
  },
  template: html,
});